import { NgModule } from '@angular/core';
import { PopoverPage } from './about-popover';
import { AboutPage } from './about';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    AboutPage,
    PopoverPage
  ],
  imports: [
    IonicModule,
    RouterModule.forChild([
      { path: '', component: AboutPage }
    ])
  ],
  entryComponents: [
    AboutPage,
    PopoverPage
  ]
})
export class AboutPageModule {}
